// ============================================================================
// Admin impersonation state (client-side)
// ============================================================================
// When an admin uses "switch as user" from the admin panel, they land on
// /auth/callback with the acting admin's identity in the URL. We stash it in
// sessionStorage so that, for the life of this tab, every worker call can carry
// the admin's identity (see impersonationFetch) and brand-side activity logs
// attribute the action to the admin rather than looking like the brand did it.
//
// sessionStorage (not localStorage) so it is scoped to this single tab and
// cleared when the tab closes — impersonation never leaks into other sessions.
// ============================================================================

const KEY = 'bmc_impersonator'

export interface Impersonator {
  id?: string | null
  email?: string | null
}

export function setImpersonator(imp: Impersonator): void {
  try {
    if (!imp || (!imp.id && !imp.email)) return
    sessionStorage.setItem(KEY, JSON.stringify({ id: imp.id ?? null, email: imp.email ?? null }))
  } catch {
    /* sessionStorage unavailable — non-fatal */
  }
}

export function getImpersonator(): Impersonator | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Impersonator
    return parsed.id || parsed.email ? parsed : null
  } catch {
    return null
  }
}

export function clearImpersonator(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    /* non-fatal */
  }
}

export function isImpersonating(): boolean {
  return getImpersonator() != null
}
